export default {
      id: "camera-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite-46b249.svg#camera-usage",
      toString: function () {
        return this.url;
      }
    }